module.exports = __webpack_public_path__ + "img/region_mid_atlantic.a7cad215.svg";